import $ from 'jquery';

const tagListV3Semantics = {
    mainWrapClass: 'tag-list-v3',
    isInitializedAttribute: 'data-is-initialized',
    instanceIdAttribute: 'data-instance-id',
    elementClass: 'tag-list-v3__item',
    linkClass: 'tag-list-v3__link',
    activeElementClass: 'tag-list-v3__item-active',
    ajaxContainerClass: 'showroom-ajax-regenerator',
    widgetTrackerClass: 'widgetTracker-showroom',
}

$(function () {
    TagListV3.init()
})

class TagListV3 {

    constructor() {
        this.pluginInstances = {};
    }

    static init() {
        let roots = $(`.${tagListV3Semantics.mainWrapClass}`);
        if (roots.length === 0) {
            return false;
        }
        if (!window || !window.widgets || !window.widgets.tagListV3) {
            window.widgets.tagListV3 = new TagListV3();
        }
        /**
         * Checking other instances
         */
        roots.each((index, el) => {
            let isInitialized =
                ($(el).attr(`${tagListV3Semantics.isInitializedAttribute}`) === 'true');

            if (!isInitialized) {
                window.widgets.tagListV3.registerInstance($(el));
                window.widgets.tagListV3.registerListeners($(el));
            }
        });
    }

    registerInstance(el) {
        let instanceId =
            el.attr(`${tagListV3Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        try {
            let object = el.find(`.${tagListV3Semantics.mainWrapClass}`);
            el.attr(`${tagListV3Semantics.isInitializedAttribute}`, true);
            window.widgets.tagListV3.pluginInstances[instanceId] = object;
        } catch(e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el)
    {
        let elements = $(`.${tagListV3Semantics.mainWrapClass}[${
            tagListV3Semantics
                .instanceIdAttribute
        }="${
            el.attr(tagListV3Semantics
                .instanceIdAttribute)
        }"]`);

        elements.on(
            'click',
            `.${tagListV3Semantics.elementClass}`,
            (e) => {
                e.preventDefault();
                let current = $(e.currentTarget);
                let showroom = current.find(`.${tagListV3Semantics.linkClass}`).attr('href');
                history.pushState({}, '', showroom);
                $.ajax({
                    url: showroom,
                    type: 'POST',
                    data: 'ajax=true',
                    headers: { 'X-CSRF-Token' : $('meta[name="csrf-token"]').attr("content") },
                    success: (data) => {
                        let container = $(`.${tagListV3Semantics.ajaxContainerClass}`);
                        container.html(data);
                        let widgetInstances = $.parseJSON(
                            container.find(`.${tagListV3Semantics.widgetTrackerClass}`).text()
                        );
                        this.reinitSubWidgets(widgetInstances);
                    }
                });
            }
        );
    }

    reinitSubWidgets(widgetInstances) {
        for(let id in widgetInstances) {
            if(window && window.widgets && window.widgets[widgetInstances[id].jsClass]) {
                window.widgets[widgetInstances[id].jsClass].reInit(
                    widgetInstances[id].widgetId
                );
            }
            else{
                throw new Error(
                    id + ' widget not found.'
                );
            }
        }
    }

    reInit(instanceId) {
        if (this.pluginInstances[instanceId] !== undefined) {
            this.registerListeners(this.pluginInstances[instanceId]);
        }
        else{
            TagListV3.init()
        }
    }
}

export default TagListV3;